import { atom } from "jotai";
import { AssetType } from "../types";

interface FocusModeAsset {
  type: AssetType | null;
  id: string | null;
}

export const focusModeAssetAtom = atom<FocusModeAsset>({
  type: null,
  id: null,
});
focusModeAssetAtom.debugLabel = "focusModeAssetAtom";
